import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["isIEG", "title", "setDocumentTitle", "component"];
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018-2022. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { injectIntl, useIntl } from 'react-intl';
import { pageView, DocumentTitleActions } from '@spm/core';
import DocumentTitleManagerContainer from '../DocumentTitleManager/DocumentTitleManagerContainer';
import translations from './RoutesMessages';

/**
 * The areEqual function is called as part of the React.memo.
 * https://reactjs.org/docs/react-api.html#reactmemo
 * It replaces previously applied shouldComponentUpdate method
 * and prevents double rendering (mounting and then updating) for pages when the URL has been directly
 * or the page has been explicitly reloaded.
 */
export var areEqual = function areEqual(prevProps, nextProps) {
  return !prevProps.isIEG && prevProps.title.id === nextProps.title.id;
};
var TitledRoute = /*#__PURE__*/React.memo(function (_ref) {
  var isIEG = _ref.isIEG,
    title = _ref.title,
    setDocumentTitle = _ref.setDocumentTitle,
    component = _ref.component,
    rest = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  useEffect(function () {
    var _window = window,
      location = _window.location;
    if (!isIEG) {
      // IEG page titles are handled by the BaseFormContainer
      var nextTitle = intl.formatMessage(translations.titleConstruct, {
        title: intl.formatMessage(title)
      });
      setDocumentTitle(nextTitle); // sets and announces page title to screen readers. necessary for SPAs

      pageView({
        title: document.title,
        location: location.href,
        path: location.pathname
      });
    }
  }, [component, title]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DocumentTitleManagerContainer, null), /*#__PURE__*/React.createElement(Route, _extends({
    component: component
  }, rest)));
}, areEqual);
TitledRoute.propTypes = process.env.NODE_ENV !== "production" ? {
  component: PropTypes.elementType.isRequired,
  intl: PropTypes.object.isRequired,
  isIEG: PropTypes.bool,
  setDocumentTitle: PropTypes.func,
  title: PropTypes.shape({
    defaultMessage: PropTypes.string,
    id: PropTypes.string
  }).isRequired
} : {};
TitledRoute.defaultProps = {
  isIEG: false,
  setDocumentTitle: function setDocumentTitle() {}
};
export function mapDispatchToProps(dispatch) {
  return {
    setDocumentTitle: function setDocumentTitle(documentTitle) {
      DocumentTitleActions.setDocumentTitle(dispatch, documentTitle);
    }
  };
}
export default connect(null, mapDispatchToProps)(injectIntl(TitledRoute));